import type {
  BadgeVariant,
  ButtonIconPlacement,
  ButtonSize,
  ButtonVariant,
} from '@property.com.au/ui-kit';
import { ArrowRightTwoMd } from '@property.com.au/ui-kit';
import type { ReactNode } from 'react';
import { CommuteSearchCTAButton } from '../CommuteAndLocationModalLocationScreen/helpers/getLocationScreenStaticData';
import { CommuteSearchCTAButtonProps } from '../CommuteAndLocationModalLocationScreen/subcomponents/CommuteSearchCTAButton';

const mapIconIdToJSXElement = (iconId?: string): ReactNode | null => {
  switch (iconId) {
    case 'ArrowRightTwoMd':
      return <ArrowRightTwoMd />;

    default:
      return null;
  }
};

export const mapCommuteSearchCTAButtonToProps = ({
  iconName,
  variant,
  sizeVariant,
  iconPlacement,
  callout,
  text,
}: CommuteSearchCTAButton): Omit<CommuteSearchCTAButtonProps, 'onClick'> => {
  return {
    text,
    icon: mapIconIdToJSXElement(iconName),
    variant: variant as ButtonVariant,
    sizeVariant: sizeVariant as ButtonSize,
    iconPlacement: iconPlacement as ButtonIconPlacement,
    callout: {
      text: callout.text,
      badgeVariant: callout.badgeVariant as BadgeVariant,
    },
  };
};
